import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { Profile } from "@/models/Profile.model";

type UserProfileType = {
  user: Profile;
  setUser: (newUser: Profile | null) => void;
};
export const useCurrentUserProfile = create(
  persist<UserProfileType>(
    (set) => ({
      user: null as unknown as Profile,
      setUser: (profile) =>
        set(() => ({
          user: profile as Profile,
        })),
    }),
    {
      name: "people_currentUser_profile",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
